"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalTypeByDecorator = exports.getClsTypeByDecorator = void 0;
require("reflect-metadata");
var getGlobalType_1 = require("./getGlobalType");
function getClsTypeByDecorator(type, target, key) {
    if (!type && Reflect && Reflect.getMetadata) {
        type = Reflect.getMetadata('design:type', target, key);
    }
    return type;
}
exports.getClsTypeByDecorator = getClsTypeByDecorator;
function getGlobalTypeByDecorator(type, target, key) {
    return getGlobalType_1.getGlobalType(getClsTypeByDecorator(type, target, key));
}
exports.getGlobalTypeByDecorator = getGlobalTypeByDecorator;
//# sourceMappingURL=getByDecorator.js.map